import apiInstance from '../../../../../api';
import {call, put} from 'redux-saga/effects';
import {
  //Notification Logs
  sendRequestNotificationLogsGetSuccess,
  sendRequestNotificationLogsGetError,
  setNotificationLogs,
} from '../../../../reducers/utils/servicesReducers/servicesLogsReducer';

//Notification Logs
export function* handleGetNotificationLogs(action) {
  const api = '/push/get?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestNotificationLogsGetSuccess());
      yield put(setNotificationLogs(response.data.data));
    } else {
      yield put(sendRequestNotificationLogsGetError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    yield put(sendRequestNotificationLogsGetError());
  }
}
